import { AxiosResponse } from 'axios';
import Api from './Api';

export default class Faturas {
  public static async get(request?: IRequestOptions): Promise<GetFaturasResponse> {
    const response = await Api.instance.get<GetFaturasResponse>(`/assinaturas/faturas`, {
      params: request?.params,
    });
    return response.data;
  }

  public static async exportar(request?: IRequestOptions): Promise<AxiosResponse<string>> {
    const response = await Api.instance.get<string>(`/assinaturas/faturas`, { params: request?.params });
    return response;
  }
}
